"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SEMANTIC_COLORS = void 0;
var _chromaJs = _interopRequireDefault(require("chroma-js"));
var _primitive_colors = require("./_primitive_colors");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0 and the Server Side Public License, v 1; you may not use this file except
 * in compliance with, at your election, the Elastic License 2.0 or the Server
 * Side Public License, v 1.
 */
var _semantic_colors = {
  plainLight: _primitive_colors.PRIMITIVE_COLORS.white,
  plainDark: _primitive_colors.PRIMITIVE_COLORS.blueBlack,
  primary10: _primitive_colors.PRIMITIVE_COLORS.blue10,
  primary20: _primitive_colors.PRIMITIVE_COLORS.blue20,
  primary30: _primitive_colors.PRIMITIVE_COLORS.blue30,
  primary40: _primitive_colors.PRIMITIVE_COLORS.blue40,
  primary50: _primitive_colors.PRIMITIVE_COLORS.blue50,
  primary60: _primitive_colors.PRIMITIVE_COLORS.blue60,
  primary70: _primitive_colors.PRIMITIVE_COLORS.blue70,
  primary80: _primitive_colors.PRIMITIVE_COLORS.blue80,
  primary90: _primitive_colors.PRIMITIVE_COLORS.blue90,
  primary100: _primitive_colors.PRIMITIVE_COLORS.blue100,
  primary110: _primitive_colors.PRIMITIVE_COLORS.blue110,
  primary120: _primitive_colors.PRIMITIVE_COLORS.blue120,
  primary130: _primitive_colors.PRIMITIVE_COLORS.blue130,
  primary140: _primitive_colors.PRIMITIVE_COLORS.blue140,
  accent10: _primitive_colors.PRIMITIVE_COLORS.pink10,
  accent20: _primitive_colors.PRIMITIVE_COLORS.pink20,
  accent30: _primitive_colors.PRIMITIVE_COLORS.pink30,
  accent40: _primitive_colors.PRIMITIVE_COLORS.pink40,
  accent50: _primitive_colors.PRIMITIVE_COLORS.pink50,
  accent60: _primitive_colors.PRIMITIVE_COLORS.pink60,
  accent70: _primitive_colors.PRIMITIVE_COLORS.pink70,
  accent80: _primitive_colors.PRIMITIVE_COLORS.pink80,
  accent90: _primitive_colors.PRIMITIVE_COLORS.pink90,
  accent100: _primitive_colors.PRIMITIVE_COLORS.pink100,
  accent110: _primitive_colors.PRIMITIVE_COLORS.pink110,
  accent120: _primitive_colors.PRIMITIVE_COLORS.pink120,
  accent130: _primitive_colors.PRIMITIVE_COLORS.pink130,
  accent140: _primitive_colors.PRIMITIVE_COLORS.pink140,
  accentSecondary10: _primitive_colors.PRIMITIVE_COLORS.teal10,
  accentSecondary20: _primitive_colors.PRIMITIVE_COLORS.teal20,
  accentSecondary30: _primitive_colors.PRIMITIVE_COLORS.teal30,
  accentSecondary40: _primitive_colors.PRIMITIVE_COLORS.teal40,
  accentSecondary50: _primitive_colors.PRIMITIVE_COLORS.teal50,
  accentSecondary60: _primitive_colors.PRIMITIVE_COLORS.teal60,
  accentSecondary70: _primitive_colors.PRIMITIVE_COLORS.teal70,
  accentSecondary80: _primitive_colors.PRIMITIVE_COLORS.teal80,
  accentSecondary90: _primitive_colors.PRIMITIVE_COLORS.teal90,
  accentSecondary100: _primitive_colors.PRIMITIVE_COLORS.teal100,
  accentSecondary110: _primitive_colors.PRIMITIVE_COLORS.teal110,
  accentSecondary120: _primitive_colors.PRIMITIVE_COLORS.teal120,
  accentSecondary130: _primitive_colors.PRIMITIVE_COLORS.teal130,
  accentSecondary140: _primitive_colors.PRIMITIVE_COLORS.teal140,
  success10: _primitive_colors.PRIMITIVE_COLORS.green10,
  success20: _primitive_colors.PRIMITIVE_COLORS.green20,
  success30: _primitive_colors.PRIMITIVE_COLORS.green30,
  success40: _primitive_colors.PRIMITIVE_COLORS.green40,
  success50: _primitive_colors.PRIMITIVE_COLORS.green50,
  success60: _primitive_colors.PRIMITIVE_COLORS.green60,
  success70: _primitive_colors.PRIMITIVE_COLORS.green70,
  success80: _primitive_colors.PRIMITIVE_COLORS.green80,
  success90: _primitive_colors.PRIMITIVE_COLORS.green90,
  success100: _primitive_colors.PRIMITIVE_COLORS.green100,
  success110: _primitive_colors.PRIMITIVE_COLORS.green110,
  success120: _primitive_colors.PRIMITIVE_COLORS.green120,
  success130: _primitive_colors.PRIMITIVE_COLORS.green130,
  success140: _primitive_colors.PRIMITIVE_COLORS.green140,
  warning10: _primitive_colors.PRIMITIVE_COLORS.yellow10,
  warning20: _primitive_colors.PRIMITIVE_COLORS.yellow20,
  warning30: _primitive_colors.PRIMITIVE_COLORS.yellow30,
  warning40: _primitive_colors.PRIMITIVE_COLORS.yellow40,
  warning50: _primitive_colors.PRIMITIVE_COLORS.yellow50,
  warning60: _primitive_colors.PRIMITIVE_COLORS.yellow60,
  warning70: _primitive_colors.PRIMITIVE_COLORS.yellow70,
  warning80: _primitive_colors.PRIMITIVE_COLORS.yellow80,
  warning90: _primitive_colors.PRIMITIVE_COLORS.yellow90,
  warning100: _primitive_colors.PRIMITIVE_COLORS.yellow100,
  warning110: _primitive_colors.PRIMITIVE_COLORS.yellow110,
  warning120: _primitive_colors.PRIMITIVE_COLORS.yellow120,
  warning130: _primitive_colors.PRIMITIVE_COLORS.yellow130,
  warning140: _primitive_colors.PRIMITIVE_COLORS.yellow140,
  danger10: _primitive_colors.PRIMITIVE_COLORS.red10,
  danger20: _primitive_colors.PRIMITIVE_COLORS.red20,
  danger30: _primitive_colors.PRIMITIVE_COLORS.red30,
  danger40: _primitive_colors.PRIMITIVE_COLORS.red40,
  danger50: _primitive_colors.PRIMITIVE_COLORS.red50,
  danger60: _primitive_colors.PRIMITIVE_COLORS.red60,
  danger70: _primitive_colors.PRIMITIVE_COLORS.red70,
  danger80: _primitive_colors.PRIMITIVE_COLORS.red80,
  danger90: _primitive_colors.PRIMITIVE_COLORS.red90,
  danger100: _primitive_colors.PRIMITIVE_COLORS.red100,
  danger110: _primitive_colors.PRIMITIVE_COLORS.red110,
  danger120: _primitive_colors.PRIMITIVE_COLORS.red120,
  danger130: _primitive_colors.PRIMITIVE_COLORS.red130,
  danger140: _primitive_colors.PRIMITIVE_COLORS.red140,
  assistance10: _primitive_colors.PRIMITIVE_COLORS.purple10,
  assistance20: _primitive_colors.PRIMITIVE_COLORS.purple20,
  assistance30: _primitive_colors.PRIMITIVE_COLORS.purple30,
  assistance40: _primitive_colors.PRIMITIVE_COLORS.purple40,
  assistance50: _primitive_colors.PRIMITIVE_COLORS.purple50,
  assistance60: _primitive_colors.PRIMITIVE_COLORS.purple60,
  assistance70: _primitive_colors.PRIMITIVE_COLORS.purple70,
  assistance80: _primitive_colors.PRIMITIVE_COLORS.purple80,
  assistance90: _primitive_colors.PRIMITIVE_COLORS.purple90,
  assistance100: _primitive_colors.PRIMITIVE_COLORS.purple100,
  assistance110: _primitive_colors.PRIMITIVE_COLORS.purple110,
  assistance120: _primitive_colors.PRIMITIVE_COLORS.purple120,
  assistance130: _primitive_colors.PRIMITIVE_COLORS.purple130,
  assistance140: _primitive_colors.PRIMITIVE_COLORS.purple140,
  shade10: _primitive_colors.PRIMITIVE_COLORS.blueGrey10,
  shade15: _primitive_colors.PRIMITIVE_COLORS.blueGrey15,
  shade20: _primitive_colors.PRIMITIVE_COLORS.blueGrey20,
  shade25: _primitive_colors.PRIMITIVE_COLORS.blueGrey25,
  shade30: _primitive_colors.PRIMITIVE_COLORS.blueGrey30,
  shade35: _primitive_colors.PRIMITIVE_COLORS.blueGrey35,
  shade40: _primitive_colors.PRIMITIVE_COLORS.blueGrey40,
  shade45: _primitive_colors.PRIMITIVE_COLORS.blueGrey45,
  shade50: _primitive_colors.PRIMITIVE_COLORS.blueGrey50,
  shade55: _primitive_colors.PRIMITIVE_COLORS.blueGrey55,
  shade60: _primitive_colors.PRIMITIVE_COLORS.blueGrey60,
  shade65: _primitive_colors.PRIMITIVE_COLORS.blueGrey65,
  shade70: _primitive_colors.PRIMITIVE_COLORS.blueGrey70,
  shade75: _primitive_colors.PRIMITIVE_COLORS.blueGrey75,
  shade80: _primitive_colors.PRIMITIVE_COLORS.blueGrey80,
  shade85: _primitive_colors.PRIMITIVE_COLORS.blueGrey85,
  shade90: _primitive_colors.PRIMITIVE_COLORS.blueGrey90,
  shade95: _primitive_colors.PRIMITIVE_COLORS.blueGrey95,
  shade100: _primitive_colors.PRIMITIVE_COLORS.blueGrey100,
  shade105: _primitive_colors.PRIMITIVE_COLORS.blueGrey105,
  shade110: _primitive_colors.PRIMITIVE_COLORS.blueGrey110,
  shade115: _primitive_colors.PRIMITIVE_COLORS.blueGrey115,
  shade120: _primitive_colors.PRIMITIVE_COLORS.blueGrey120,
  shade125: _primitive_colors.PRIMITIVE_COLORS.blueGrey125,
  shade130: _primitive_colors.PRIMITIVE_COLORS.blueGrey130,
  shade135: _primitive_colors.PRIMITIVE_COLORS.blueGrey135,
  shade140: _primitive_colors.PRIMITIVE_COLORS.blueGrey140,
  shade145: _primitive_colors.PRIMITIVE_COLORS.blueGrey145
};
var _semantic_rgb_colors = {
  plainLightRGB: (0, _chromaJs["default"])(_semantic_colors.plainLight).rgb().join(),
  primary70RGB: (0, _chromaJs["default"])(_semantic_colors.primary70).rgb().join(),
  primary100RGB: (0, _chromaJs["default"])(_semantic_colors.primary100).rgb().join(),
  accent70RGB: (0, _chromaJs["default"])(_semantic_colors.accent70).rgb().join(),
  accentSecondary70RGB: (0, _chromaJs["default"])(_semantic_colors.accentSecondary70).rgb().join(),
  success70RGB: (0, _chromaJs["default"])(_semantic_colors.success70).rgb().join(),
  warning40RGB: (0, _chromaJs["default"])(_semantic_colors.warning40).rgb().join(),
  danger70RGB: (0, _chromaJs["default"])(_semantic_colors.danger70).rgb().join(),
  shade100RGB: (0, _chromaJs["default"])(_semantic_colors.shade100).rgb().join(),
  shade120RGB: (0, _chromaJs["default"])(_semantic_colors.shade120).rgb().join(),
  shade140RGB: (0, _chromaJs["default"])(_semantic_colors.shade140).rgb().join()
};
var _semantic_alpha_colors = {
  plainLightAlpha8: "rgba(".concat(_semantic_rgb_colors.plainLightRGB, ", 0.08)"),
  plainLightAlpha12: "rgba(".concat(_semantic_rgb_colors.plainLightRGB, ", 0.12)"),
  plainLightAlpha16: "rgba(".concat(_semantic_rgb_colors.plainLightRGB, ", 0.16)"),
  plainLightAlpha32: "rgba(".concat(_semantic_rgb_colors.plainLightRGB, ", 0.32)"),
  primary70Alpha12: "rgba(".concat(_semantic_rgb_colors.primary70RGB, ", 0.12)"),
  primary70Alpha16: "rgba(".concat(_semantic_rgb_colors.primary70RGB, ", 0.16)"),
  primary100Alpha4: "rgba(".concat(_semantic_rgb_colors.primary100RGB, ", 0.04)"),
  primary100Alpha8: "rgba(".concat(_semantic_rgb_colors.primary100RGB, ", 0.08)"),
  primary100Alpha12: "rgba(".concat(_semantic_rgb_colors.primary100RGB, ", 0.12)"),
  accent70Alpha12: "rgba(".concat(_semantic_rgb_colors.accent70RGB, ", 0.12)"),
  accent70Alpha16: "rgba(".concat(_semantic_rgb_colors.accent70RGB, ", 0.16)"),
  accentSecondary70Alpha12: "rgba(".concat(_semantic_rgb_colors.accentSecondary70RGB, ", 0.12)"),
  accentSecondary70Alpha16: "rgba(".concat(_semantic_rgb_colors.accentSecondary70RGB, ", 0.16)"),
  success70Alpha12: "rgba(".concat(_semantic_rgb_colors.success70RGB, ", 0.12)"),
  success70Alpha16: "rgba(".concat(_semantic_rgb_colors.success70RGB, ", 0.16)"),
  warning40Alpha12: "rgba(".concat(_semantic_rgb_colors.warning40RGB, ", 0.12)"),
  warning40Alpha24: "rgba(".concat(_semantic_rgb_colors.warning40RGB, ", 0.24)"),
  danger70Alpha12: "rgba(".concat(_semantic_rgb_colors.danger70RGB, ", 0.12)"),
  danger70Alpha16: "rgba(".concat(_semantic_rgb_colors.danger70RGB, ", 0.16)"),
  shade100Alpha4: "rgba(".concat(_semantic_rgb_colors.shade100RGB, ", 0.04)"),
  shade100Alpha16: "rgba(".concat(_semantic_rgb_colors.shade100RGB, ", 0.16)"),
  shade100Alpha24: "rgba(".concat(_semantic_rgb_colors.shade100RGB, ", 0.24)"),
  shade100Alpha70: "rgba(".concat(_semantic_rgb_colors.shade100RGB, ", 0.7)"),
  shade120Alpha70: "rgba(".concat(_semantic_rgb_colors.shade120RGB, ", 0.7)")
};
var SEMANTIC_COLORS = exports.SEMANTIC_COLORS = _objectSpread(_objectSpread(_objectSpread({}, _semantic_colors), _semantic_alpha_colors), _semantic_rgb_colors);
//# sourceMappingURL=_semantic_colors.js.map